import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Expand_left_double_light",
  "use": "Expand_left_double_light-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Expand_left_double_light\">\r\n<path d=\"M12 18L6 12L12 6\" stroke=\"#8D8D8D\" stroke-linecap=\"round\" />\r\n<path d=\"M18 18L12 12L18 6\" stroke=\"#8D8D8D\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol